import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(dvr => ({
        value: dvr.id,
        label: dvr.name,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      try {
        const { data } = await axios.get('v1/services/pacom/sites', { params });

        if (!data) {
          return []
        }

        commit('setData', data.data);
        return data;

      } catch (error) {
        console.error('Error fetching items:', error);
        return [];
      }
    },
    async add(_, params) {
      const { data } = await axios.post('v1/services/pacom/sites', params)

      return data
    },
    async show(_, id) {
      const { data } = await axios.get(`v1/services/pacom/sites/${id}`)

      return data
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/services/pacom/sites/${id}`, params)

      return data
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/services/pacom/sites/${id}`)

      return data
    },
    async addEntries(_, params) {
      const { data } = await axios.post('v1/services/pacom/sites/add-entries', params)

      return data
    },
    async lastVersion(_, id) {
      console.log(id);
      const { data } = await axios.get(`v1/services/pacom/sites/${id}/last-version`)

      return data
    },
    async getEvents(_, params) {
      const { id,lastVersion } = params;
      const { data } = await axios.get(`v1/services/pacom/sites/${id}/events/${lastVersion}`)

      return data
    },
    clear({ commit }) {
      commit('setData', [])
    }
  },
}
